<template>
    <div class="col-sm-12 my-1">
        <b-card class="p-0" body-class="p-0">
            <template #header>
                <h6 class="card-subtitle">
                    <font-awesome-icon class="mr-2" icon="bullhorn" />
                    Notifications
                </h6>
            </template>
            <b-list-group flush> 
                <template v-if="notifications.length">
                    <b-list-group-item
                        v-for="(notification, idx) in notifications"
                        :key="idx"
                    >
                        <b>
                            <font-awesome-icon
                                v-if="notification.icon"
                                :icon="notification.icon"
                            ></font-awesome-icon>
                            {{ notification.caption }}
                        </b>
                        <div v-if="notification.content != null">
                            <p
                                v-for="(p, idx) in notification.content.split('\n')"
                                :key="idx"
                            >
                                {{ p }}
                            </p>
                        </div>
                        <div v-else></div>
                        <a
                            v-if="notification.link"
                            :href="notification.link"
                            is="b-button"
                            variant="outline-primary"
                            class="notification-link"
                        >
                            <font-awesome-icon :icon="(notification.link_icon) ? notification.link_icon : 'link'"></font-awesome-icon>
                            {{ notification.link_title }}
                        </a>
                    </b-list-group-item>
                </template>
                <b-list-group-item v-else-if="loading">
                    <b-skeleton></b-skeleton>
                </b-list-group-item>
                <b-list-group-item v-else>
                    <font-awesome-icon icon="info-circle"></font-awesome-icon>
                    <span class="m-3">No notifications to see here!</span>
                </b-list-group-item>
            </b-list-group>
        </b-card>
    </div>
</template>
<script>
export default {
    data() {
        return {
            notifications: [],
            loading: true
        };
    },
    created() {
        this.loadNotifications();
    },
    methods: {
        loadNotifications() {
            this.loading = true;
            this.$api.get(
                "/api/notifications/list"
            ).then(({ data: { records } }) => {
                this.notifications = records;
                this.loading = false;
            });
        }
    }
}
</script>